import { render, staticRenderFns } from "./vipGift.vue?vue&type=template&id=83a0eba2&scoped=true&"
import script from "./vipGift.vue?vue&type=script&lang=js&"
export * from "./vipGift.vue?vue&type=script&lang=js&"
import style0 from "./vipGift.vue?vue&type=style&index=0&id=83a0eba2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a0eba2",
  null
  
)

export default component.exports